module.exports = "/dist/assets/images/arrow-left.svg";